// src/modules/app-views/_apps/appmulti/operators/service.js
// *******************************************************************************
// HELPER FUNCTIONS FOR OPERATORS MODULE
// *******************************************************************************

// *******************************************************************************
// CURRENCIES
// *******************************************************************************
function getCurrencies() {
  return [
    { label: 'USD ($)', value: 'USD' },
    { label: 'EUR (€)', value: 'EUR' },
    { label: 'GBP (£)', value: 'GBP' },
    { label: 'CAD (C$)', value: 'CAD' },
    { label: 'AUD (A$)', value: 'AUD' },
    { label: 'BRL (R$)', value: 'BRL' },
  ];
}

// *******************************************************************************
// APIS
// *******************************************************************************
function getApis() {
  return [
    { label: 'Assist Card', value: 'assist_card' },
    { label: 'Affinity', value: 'affinity' },
    { label: 'Coris', value: 'coris' },
    { label: 'GTA', value: 'gta' },
    { label: 'Intermac', value: 'intermac' },
    { label: 'Travel Ace', value: 'travel_ace' },
    { label: 'Universal Assistance', value: 'universal_assistance' },
    { label: 'Vital Card', value: 'vitalcard' },
  ];
}

// *******************************************************************************
// EXCHANGE HISTORY
// *******************************************************************************
function buildExchangeHistory(currentExchanges, newRate, newCurrency) {
  const exchanges = Array.isArray(currentExchanges) ? [...currentExchanges] : [];

  if (!newRate || !newCurrency) return exchanges;

  // Add new exchange entry with timestamp
  exchanges.push({
    rate: newRate,
    currency: newCurrency,
    date: new Date().toISOString(),
  });

  return exchanges;
}

// *******************************************************************************
// CURRENCY SYMBOL
// *******************************************************************************
function getCurrencySymbol(currencyCode) {
  const symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$',
    BRL: 'R$',
  };
  return symbols[currencyCode] || currencyCode || '';
}

// *******************************************************************************
// CNPJ REGISTRY (synced with backend)
// *******************************************************************************
const CNPJ_REGISTRY = {
  '17846647000131': {
    provider: 'affinity',
    name: 'Affinity Seguro Viagem',
    cnpjFormatted: '17.846.647/0001-31',
  },
  '00027571000110': {
    provider: 'assistcard',
    name: 'Assist Card Do Brasil Ltda',
    cnpjFormatted: '00.027.571/0001-10',
  },
  '04789159000198': {
    provider: 'coris',
    name: 'Coris Brasil Turismo Viagens E Assistencia Internacional Ltda',
    cnpjFormatted: '04.789.159/0001-98',
  },
  '05948059000120': {
    provider: 'gta',
    name: 'Brazilian Assist Representacoes E Turismo Ltda',
    cnpjFormatted: '05.948.059/0001-20',
  },
  '05880321000141': {
    provider: 'intermac',
    name: 'Intermac Brasil - Assistencia Ao Turismo Ltda',
    cnpjFormatted: '05.880.321/0001-41',
  },
  '04628135000157': {
    provider: 'vitalcard',
    name: 'Vital Card',
    cnpjFormatted: '04.628.135/0001-57',
  },
};

function resolveProviderByCnpj(cnpj) {
  if (!cnpj) return null;
  const clean = cnpj.replace(/\D/g, ''); // Remove formatting
  return CNPJ_REGISTRY[clean] || null;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
const operatorsService = {
  getCurrencies,
  getApis,
  buildExchangeHistory,
  getCurrencySymbol,
  resolveProviderByCnpj,
  CNPJ_REGISTRY,
};

export default operatorsService;
